import { useQuery } from "@tanstack/react-query";
import { dashboardRuntimeApi } from "./dashboard-runtime.api";

export const dashboardRuntimeKeys = {
	all: ["dashboard-runtime"] as const,
	source: (workflowId: string) => [...dashboardRuntimeKeys.all, "source", workflowId] as const,
};

export const useGetDashboard = (workflowId: string) => {
	return useQuery({
		queryKey: dashboardRuntimeKeys.source(workflowId),
		queryFn: () => dashboardRuntimeApi.getSource(workflowId),
		enabled: Boolean(workflowId),
	});
};
